export default "__VITE_ASSET____DYmJFe__"